// Mixpanel Event Property Names

// Content & Structure properties
export const ELEMENT_TYPE = 'Element type';
export const SOURCE = 'Source';

// Preview & Publish properties
export const PUBLISH_TARGET = 'Publish target';
export const LOAD_TIME = 'Load time';
export const ERROR_TYPE = 'Error type';
export const DOMAIN = 'Domain';
export const DOMAIN_TYPE = 'Domain type';

// Inspiration properties
export const TEMPLATE_ID = 'Template ID';
export const TEMPLATE_NAME = 'Template name';

// Canvas & Layout properties
export const VIEW_TYPE = 'View type';

// Settings properties
export const PANE = 'Pane';

// Integrations & Automation properties
export const PANEL_STATE = 'Panel state';
export const STEP = 'Step';
export const INTEGRATION_NAME = 'Integration name';
export const IS_NEW_CONNECTION = 'Is new connection';
export const CONNECTION_METHOD = 'Connection method';
export const FIELDS_MAPPED = 'Fields mapped';

// AI Generation properties
export const AI_ACTION = 'AI Action';
export const AI_MODEL = 'AI Model';
export const AI_DURATION_MS = 'AI Duration (ms)';
export const AI_GENERATION_MODE = 'AI Generation Mode';
export const AI_SUCCESS = 'AI Success';
export const AI_TOTAL_DURATION_MS = 'AI Total Duration (ms)';
export const AI_INPUT_TOKENS = 'AI Input Tokens';
export const AI_OUTPUT_TOKENS = 'AI Output Tokens';
export const AI_TOTAL_TOKENS = 'AI Total Tokens';
export const AI_SECTION_COUNT = 'AI Section Count';
export const AI_PLAN_DURATION_MS = 'AI Plan Duration (ms)';
export const AI_LONGEST_SECTION_DURATION_MS = 'AI Longest Section Duration (ms)';
export const AI_HAS_SCREENSHOT = 'AI Has Screenshot';
export const AI_ERROR = 'AI Error';
